<template>
  <div
    ref="modalRef"
    class="modal"
    :class="isShown ? 'modal_active' : ''"
    @click="check"
  >
    <div
      class="modal_in"
    >
      <div
        v-if="closeButtonOutside"
        class="closeButtonOutside"
      >
        <AppButton
          variant="secondary"
          @click="$emit('close')"
        >
          <Icon
            :icon="require(`@/assets/icons/white_24_cross.svg`)"
          />
        </AppButton>
      </div>

      <div
        v-if="title || hasTitleClose"
        class="modal_top"
      >
        <div>
          {{ title }}
        </div>

        <button
          v-if="hasTitleClose && !closeButtonOutside"
          class="close_modal"
          @click="$emit('close')"
        >
          <img
            src="@/assets/images/modal_close.svg"
            alt=""
          />
        </button>
      </div>

      <slot />
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue'
import AppButton from '@/components/UI/AppButton.vue'
import Icon from '@/components/UI/Icon.vue'
import {useModalScrollingFix} from '@/hooks/useModalScrollingFix'

const modalScrollingFix = useModalScrollingFix()

const modalRef = ref(null)

const emit = defineEmits(['close'])

const props = defineProps({
  closeOnClickAway: {
    type: Boolean,
    default: true,
  },
  isShown: {
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  hasTitleClose: {
    type: Boolean,
    default: true,
  },
  closeButtonOutside: {
    type: Boolean,
    default: false,
  }
})

watch(() => props.isShown, (value) => {
  if(value) {
    modalScrollingFix.open()
  } else {
    modalScrollingFix.close()
  }
})

function check(event) {
  if (event.target === modalRef.value && props.closeOnClickAway) {
    emit('close')
  }
}

</script>

<style lang="scss" scoped>
.modal {
  height: 0;
  width: 0;
  backdrop-filter: blur(13px);
  transform: translate3d(0, 0, 0);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: end;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  transition: transform .5s, backdrop-filter .5s;

  .modal_in {
    max-width: 480px;
    width: 100%;
    border-radius: 16px 16px 0 0;
    background: var(--card-secondary-background);
    padding: 16px;
    transform: translateY(500px);
    //transition: transform 0.5s ease;
    transition: transform .5s, backdrop-filter .5s;

    .modal_top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--text-primary-color);
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0;
      margin-bottom: 20px;
    }
  }
}

.modal_active {
  opacity: 1;
  z-index: 1001;
  height: 100%;
  width: 100%;

  .modal_in {
    transform: translateY(0);
  }
}

.closeButtonOutside {
  position: absolute;
  right: 16px;
  top: -54px;
}
</style>
